import './ClipsGrid.sass';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { listReelsByIdSelector, reelsLoadingStatusSelector } from '$store/reels';
import { Loader } from '$shared/components';
import { IcPlusCircle28, IcViews24 } from '$assets';
import { useRouter } from 'react-router5';
import { PROFILE_REELS } from '$shared/constants/pages';
import { showModal } from '$navigation/helper';
import { RootState } from '$store/rootReducer';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import { formatBigNumber } from '$utils';

interface ClipsGridProps {
  profileId: number;
}

export const ClipsGrid: FC<ClipsGridProps> = ({ profileId }) => {
  const t = useTranslator();
  const loadingStatus = useSelector(reelsLoadingStatusSelector);
  const isLoading = loadingStatus === 'loading';
  const currentUser = useCurrentUserInfo();
  const router = useRouter();
  const reels = useSelector((state: RootState) =>
    listReelsByIdSelector(state, profileId),
  );
  const isCurrentUserProfilePage = currentUser.id === profileId;

  const isUserReels = !!reels?.length;

  if (isLoading) {
    return <Loader isWrapped />;
  }

  return (
    <div className={'clipsGrid'}>
      {isCurrentUserProfilePage && (
        <div
          className={'clipsGrid__item clipsGrid__new'}
          onClick={() => showModal('reel')}
        >
          <div className={'clipsGrid__create'}>
            <IcPlusCircle28 />
            {t('clips_add')}
          </div>
        </div>
      )}
      {isUserReels &&
        reels.map(({ views, poster }, index) => (
          <div
            onClick={() =>
              router.navigate(PROFILE_REELS, { id: profileId, activeIndex: index })
            }
            style={{ backgroundImage: `url("${poster}")` }}
            className={'clipsGrid__item'}
            key={poster}
          >
            <div className={'clipsGrid__gradient'} />
            <div className={'clipsGrid__views'}>
              <IcViews24 className={'clipsGrid__icon'} />
              {formatBigNumber(views)}
            </div>
          </div>
        ))}
    </div>
  );
};
